function toRad($Value) {
    return $Value * Math.PI / 180;
}

function calcCrow(point1, point2, unit = 'm'){
    const $R = {
        'm': 6371000,
        'km': 6371
    }[unit];
    let $lat1 = point1.lat;
    let $lat2 = point2.lat;
    let $lon1 = point1.lng;
    let $lon2 = point2.lng;

    const $dLat = toRad($lat2-$lat1);
    const $dLon = toRad($lon2-$lon1);
    $lat1 = toRad($lat1);
    $lat2 = toRad($lat2);

    const $a = Math.sin($dLat/2) * Math.sin($dLat/2) + Math.sin($dLon/2) * Math.sin($dLon/2) * Math.cos($lat1) * Math.cos($lat2);
    const $c = 2 * Math.atan2(Math.sqrt($a), Math.sqrt(1-$a));
    return $R * $c;
}

export function getDistance (posA, posB, unit = 'm') {
    return calcCrow(posA, posB, unit);
}



// WEBPACK FOOTER //
// ./src/helpers/gps.helper.js